/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

function ActionCell({ id, filtered, row, handleApplyAction }) {
  return (
    <SoftBox display="flex" alignItems="center">
      <SoftBox mx={2}>
        <SoftTypography
          variant="body1"
          sx={{
            cursor: "pointer",
            lineHeight: 0,
            display: row.original.hasOwnProperty("operFiltered")
              ? row.original.operFiltered
                ? ""
                : "none"
              : filtered
              ? ""
              : "none",
            color: "green",
            opacity: 0.5,
          }}
        >
          <Tooltip
            title="Start Feed Market"
            placement="top"
            sx={{
              display: row.original.hasOwnProperty("operFiltered")
                ? row.original.operFiltered
                  ? ""
                  : "none"
                : filtered
                ? ""
                : "none",
            }}
          >
            <Icon
              variant="button"
              onClick={(e) => handleApplyAction(e, id, row, filtered)}
              className="play-action"
            >
              play_circle_filled_white_outlined_icon{" "}
            </Icon>
          </Tooltip>
        </SoftTypography>
        <SoftTypography
          variant="body1"
          sx={{
            cursor: "pointer",
            lineHeight: 0,
            display: row.original.hasOwnProperty("operFiltered")
              ? row.original.operFiltered
                ? "none"
                : ""
              : filtered
              ? "none"
              : "",
            color: "red",
            opacity: 0.7,
          }}
        >
          <Tooltip
            title="Stop Feed Market"
            placement="top"
            sx={{
              display: row.original.hasOwnProperty("operFiltered")
                ? row.original.operFiltered
                  ? "none"
                  : ""
                : filtered
                ? "none"
                : "",
            }}
          >
            <Icon
              variant="button"
              onClick={(e) => handleApplyAction(e, id, row, filtered)}
              className="stop-action"
            >
              stop_circle_outlined_icon{" "}
            </Icon>
          </Tooltip>
        </SoftTypography>
      </SoftBox>
    </SoftBox>
  );
}

// Typechecking props of the CreateTemplate
ActionCell.propTypes = {
  id: PropTypes.number,
  filtered: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  row: PropTypes.object,
  handleApplyAction: PropTypes.func,
};

export default ActionCell;
